<style scoped>
.address-form-group {
    margin-bottom: 0;
}
.address-block-label {
    font-size: 1em;
}
</style>
<template>
    <fieldset class="form-group clearfix" :class="[colClass]">
        <legend :aria-label="effectiveLabelText" class="highlight-on-child-error address-block-label control-label" v-if="effectiveLabelText == effectiveLabel" :class="settings.required && singleLabel ? 'dfRequired' : ''" :style="singleLabel ? 'margin-bottom:10px' : ''">
            {{ effectiveLabelText }}
            <HelpIcon :text="settings.helpText" v-if="!isViewOnly" />
        </legend>

        <ChildrenList :children-ids="children" :view-only="isViewOnly"></ChildrenList>

        <div class="dfCompositControlChildMargin" data-ng-bind="settings.showErrorsLocally">
            <div v-for="child in children">
                <ErrorList :data="child" :force-non-local="true" :id="child.vmId + '_Errors'" />
            </div>
        </div>
        <Comments :data="data" />
        <AdminSettingsDifferences :data="data" />
    </fieldset>
</template>
<script lang="ts">
import { defineComponent, computed } from "vue";
import { props, Props, components, setup } from "./BaseDefMixin.3";
import type DatePickerDef from "../elements/DatePickerDef";
import { DatePickerSettings } from "@cs-ts/date-picker-settings";
import { useObservable } from "@vueuse/rxjs";
export default defineComponent({
    components: {
        ...components,
        //DatePicker,
    },
    props: props,
    //@ts-ignore
    setup(props: Props<DatePickerDef, DatePickerSettings>) {
        const base = setup<DatePickerDef, DatePickerSettings>(props);

        const singleLabel = computed(() => base.settings.value.layout == 2 || base.settings.value.datePeriod == 0); // combined or year (which is always one label)

        const effectiveLabel = useObservable(props.data.effectiveLabel$());
        const effectiveLabelText = useObservable(props.data.effectiveLabelText$());

        return {
            singleLabel,
            effectiveLabel,
            effectiveLabelText,

            ...base.expose,
        };
    },
});
</script>
